import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import React, { useContext } from 'react';

import CardList from '../../cards/CardList';
import { FollowBrandContext } from '../../FollowBrand/FollowBrandContext';
import { FollowableBrandCard } from './FollowableBrandCard';
import { FollowingBrandCard } from './FollowingBrandCard';
import * as S from './styled';

export function FollowedBrands() {
  const { availableBrands, followedBrands } = useContext(FollowBrandContext);

  if (followedBrands === undefined) {
    return null;
  }

  const isFollowingBrands = followedBrands.length > 0;

  return (
    <>
      {!isFollowingBrands && (
        <>
          <GridItem columnStartSm="1" columnEndSm="12">
            <S.Title element="h2" variant="one">
              Titels die je kunt volgen
            </S.Title>
            Volg jouw favoriete BNNVARA-titel! Hier op het profiel tonen we het
            overzicht van jouw titels.
          </GridItem>
          <CardList
            viewType="Default"
            items={availableBrands}
            renderCard={FollowableBrandCard}
          />
        </>
      )}
      {isFollowingBrands && (
        <>
          <GridItem columnStartSm="1" columnEndSm="12">
            <Heading element="h2" variant="one">
              Titels die je volgt
            </Heading>
          </GridItem>
          <CardList
            viewType="Default"
            items={followedBrands}
            renderCard={FollowingBrandCard}
          />
        </>
      )}
    </>
  );
}
